export default "__VITE_ASSET__KrgkXQaQ__"